import {HStack} from '../HStack/HStack';
import {type StackProps} from '../Stack/Stack';

interface RightProps extends Pick<StackProps, 'children' | 'align' | 'width' | 'height'> {}

export function Right(props: RightProps) {
  return <HStack justify="flex-end" {...props} />;
}
